// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"1830ed35","174":"d48ba40a","209":"84c51335","328":"17380fa2","889":"5be60b52"}[chunkId] + ".chunk.css";
};